import { useState, useEffect } from 'react';
import { FILE_INGESTION_LOGS } from 'graphql/fileIngestionLogs.gql';
import { formatToAtlanticTime } from '../../utils/dateFormatter';
import { usePaginatedGraphQl } from '@hooks/graphql/usePaginatedGraphQl';

export const useFileIngestionLogsData = () => {
  const {
    loading,
    updating,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    fetchError,
    fetchData,
    updateError,
  } = usePaginatedGraphQl(FILE_INGESTION_LOGS, null, (params) => params);

  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setData(
      (fetchData?.fileIngestionLogs?.nodes ?? []).map((record) => ({
        ...record,
        ingestionTimestampFormatted: formatToAtlanticTime(record.ingestionTimestamp, 'full'),
        // Ensure rejects is always an array
        rejects: record.rejects || [],
        rejectRecordCount: record.rejectRecordCount || 0,
      }))
    );
    setTotalCount(fetchData?.fileIngestionLogs?.totalCount ?? 0);
  }, [fetchData]);

  return {
    data,
    totalCount,
    loading,
    updating,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    errorFromUseData: fetchError || updateError,
    setUpdatedRecord: () => { },
  };
};